<template>
  <div class="global-container">
    <div class="space-3"></div>
    <h1>Datenschutzerklärung</h1>
    <h3>1. Allgemeine Hinweise</h3>
    <p>
      Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir
      verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen
      Bestimmungen (DSGVO, TKG 2003). Diese Datenschutzerklärung informiert Sie
      darüber, ob und welche Daten beim Besuch dieser Website verarbeitet
      werden.
    </p>
    <h3>2. Keine Verarbeitung personenbezogener Daten</h3>
    <p>
      Unsere Website www.helpingheads.at dient ausschließlich der Bereitstellung
      von Informationen. Wir erheben, speichern oder verarbeiten keinerlei
      personenbezogene Daten der Besucher. Es werden keine Cookies gesetzt. Es
      wird kein Tracking (z. B. Google Analytics) verwendet. Es gibt keine
      Kontaktformulare oder Nutzerkonten.
    </p>
    <h3>3. Server-Logfiles</h3>
    <p>
      Beim Besuch dieser Website speichert der Webserver automatisch bestimmte
      Informationen (sogenannte Server-Logfiles), die von Ihrem Browser
      übermittelt werden. Diese können Folgendes umfassen: IP-Adresse Datum und
      Uhrzeit des Zugriffs Aufgerufene Seiten Browsertyp und -version
      Betriebssystem Diese Daten dienen ausschließlich der technischen
      Überwachung und Sicherheit der Website und werden nicht mit anderen
      Datenquellen zusammengeführt. Eine personenbezogene Auswertung findet
      nicht statt.
    </p>
    <h3>4. Kontakt</h3>
    <p>
      Sollten Sie Fragen zum Datenschutz haben, können Sie uns jederzeit
      kontaktieren:
    </p>
    <p>helping heads – projektentwicklung</p>
    <p>Kurt Berger</p>
    <p>Telefon: +43 664 3322677</p>
    <p>E-Mail: kurt@helpingheads.at</p>
    <p></p>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
h3 {
  margin-top: map-get($spaces, lg);
  margin-bottom: map-get($spaces, xxs);
}
</style>
